var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGrayStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.041,
    height: 30.26,
    viewBox: "0 0 31.041 30.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M22.389,10.122,20.36,3.716a3,3,0,0,0-5.72,0l-2.029,6.405a1,1,0,0,1-.953.7H4.986a3,3,0,0,0-1.793,5.406l5.484,4.087a1,1,0,0,1,.356,1.1L6.959,27.963a3,3,0,0,0,4.652,3.312L16.9,27.332a1,1,0,0,1,1.195,0l5.291,3.943a3,3,0,0,0,4.652-3.312l-2.074-6.547a1,1,0,0,1,.356-1.1l5.484-4.087a3,3,0,0,0-1.792-5.406H23.342A1,1,0,0,1,22.389,10.122Z",
    transform: "translate(-1.98 -1.622)",
    fill: "#d1d1d1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayStar);
export default __webpack_public_path__ + "static/media/gray-star.014dbcf02d94b04fc5617c63d3e4f64a.svg";
export { ForwardRef as ReactComponent };